/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_BackInputs */



/**
* | output |
* | --- |
* | "Back" |
*
* @param {Tournament_Wiz_BackInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_back = /** @type {((inputs?: Tournament_Wiz_BackInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_BackInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour")
	if (locale === "es") return /** @type {LocalizedString} */ ("Atrás")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Voltar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indietro")
	return /** @type {LocalizedString} */ ("Back")
});